import TitleBlock from './TitleBlock/ConfiguratorTitleBlock';
import Main from './Main/ConfiguratorMain';
import Loader from '../ui/Loader/Loader';
import React, { Suspense } from 'react';
import '../../../assets/styles/main.scss';

export default function CarConfiguratorPage({ fields }) {
  return (
    <div className="container">
      <Suspense fallback={<Loader />}>
        <Main sitecoreData={fields} />
      </Suspense>
    </div>
  );
}
